import * as React from 'react';

import Question16 from './Question16';

export const question16 = () => <Question16 />;

export default {
    title: 'Icon|Line|Question16',
    component: Question16,
    parameters: {
        notes: "`import Question16 from 'box-ui-elements/es/icon/line/Question16';`",
    },
};
